exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label{font-size:1rem}.Input__label{font-weight:bold;font-size:1rem}.Input__field{border:1px solid #000;padding:23px 15px}.Form__inputWrapper{margin-top:10px}", ""]);

// exports
